/**
 * In-tab bus for agent Online/Away changes (socket + local presence toggle).
 * Users / routing pages subscribe so Accepting status is not a one-shot directory snapshot.
 */

/** @typedef {{ agentEmail?: string | null, agentId?: string | number | null, isOnline: boolean, status?: string }} AgentStatusChangedPayload */

/** @type {Set<(payload: AgentStatusChangedPayload) => void>} */
const listeners = new Set();

/** @param {(payload: AgentStatusChangedPayload) => void} fn */
export function subscribeAgentStatusChanged(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** @param {AgentStatusChangedPayload} payload */
export function notifyAgentStatusChanged(payload) {
  if (!payload) return;
  for (const fn of listeners) {
    try {
      fn(payload);
    } catch {
      /* subscriber errors must not break presence */
    }
  }
}
